import type {
  LocationCreateRequest,
  OrganisationCreateRequest,
} from "@safeplate/contracts";

export interface OnboardingForm {
  city: string;
  legalName: string;
  // null until the owner types one; until then it follows the business name.
  locationName: string | null;
  tradingName: string;
}

export function onboardingRequests(form: OnboardingForm): {
  location: LocationCreateRequest;
  organisation: OrganisationCreateRequest;
} {
  const legalName = form.legalName.trim();
  const tradingName = form.tradingName.trim();
  const city = form.city.trim();
  return {
    location: {
      address: city ? { city } : {},
      licensable: true,
      name: (form.locationName ?? (tradingName || legalName)).trim(),
      status: "active",
      timezone: "Pacific/Auckland",
    },
    organisation: {
      billing_email: null,
      legal_name: legalName,
      trading_name: tradingName || null,
    },
  };
}
